import { OnDateRangeFilter, ResetDateFilter } from '@erecruit/modules';
import { Resources } from '@erecruit/types';

import { positionColumns } from '../../../PositionSearch/columns';

export const defaultVisibleColumns = [
  nameof<Resources.PositionSearch>(o => o.name),
  nameof<Resources.PositionSearch>(o => o.createdOn),
  nameof.full<Resources.PositionSearch>(o => o.contact.name),
  nameof<Resources.PositionSearch>(o => o.companyDepartments),
];

export const generateColumns = (
  filterByDate: OnDateRangeFilter,
  resetDateFilter: ResetDateFilter,
  filterState: Resources.PositionSearchFilter,
) => [
  positionColumns.getPositionColumn({}),
  positionColumns.getPositionCreatedOnColumn(
    filterState,
    resetDateFilter,
    filterByDate,
  ),
  positionColumns.getPositionContactColumn(filterState),
  positionColumns.getPositionDepartmentColumn(filterState),
];
